import React, { useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import ImageUpload from './ImageUpload';
import './Modal.css';

export default function ModalEvento({ onClose, onCreado }) {
  const hoy = new Date().toISOString().split('T')[0];
  const [form, setForm] = useState({
    nombre:'', tipo:'capacitacion', fecha:hoy, horaInicio:'10:00', horaFin:'12:00',
    voluntariosNecesarios:5, metaFondos:0,
    descripcion:'', ubicacion:'', modalidad:'presencial', esDePago:false, precio:0,
    propositoRecaudacion:'', linkTransmision:''
  });
  const [imagen, setImagen] = useState(null);
  const [loading, setLoading] = useState(false);

  const handle = e => {
    const { name, value, type, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const submit = async e => {
    e.preventDefault();
    if (form.horaFin && form.horaInicio && form.horaFin < form.horaInicio) {
      toast.error('La hora de fin debe ser posterior a la de inicio');
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach(key => {
        if (form[key] !== undefined && form[key] !== null) {
          formData.append(key, form[key]);
        }
      });
      if (imagen) formData.append('imagen', imagen);
      await api.post('/eventos', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success(`¡"${form.nombre}" programada con éxito! 📅`);
      onCreado(); onClose();
    } catch (err) {
      toast.error(err.response?.data?.msg || 'Error al crear');
    } finally { setLoading(false); }
  };

  return (
    <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal fade-up">
        <button className="modal-close" onClick={onClose}>✕</button>
        <h2>Nueva actividad / Clase</h2>
        <p className="modal-sub">Configura una nueva actividad para la comunidad</p>
        <form onSubmit={submit}>
          <div className="f-group">
            <label className="f-lbl">Nombre</label>
            <input className="f-inp" name="nombre" placeholder="Ej: Clase de Yoga Pro-Rescate" value={form.nombre} onChange={handle} required />
          </div>

          <div className="f-row">
            <div className="f-group">
              <label className="f-lbl">Fecha</label>
              <input className="f-inp" name="fecha" type="date" min={hoy} value={form.fecha} onChange={handle} required />
            </div>
            <div className="f-group">
              <label className="f-lbl">Tipo de Actividad</label>
              <select className="f-inp" name="tipo" value={form.tipo} onChange={handle}>
                <option value="capacitacion">🎓 Clase / Taller</option>
                <option value="rescate">🐾 Rescate</option>
                <option value="adopcion">🏡 Adopción</option>
                <option value="vacunacion">💉 Vacunación</option>
                <option value="alimentacion">🦴 Alimentación</option>
                <option value="otro">✨ Otro</option>
              </select>
            </div>
          </div>

          <div className="f-row">
            <div className="f-group">
              <label className="f-lbl">🕐 Hora de inicio</label>
              <input className="f-inp" name="horaInicio" type="time" value={form.horaInicio} onChange={handle} required />
            </div>
            <div className="f-group">
              <label className="f-lbl">🕑 Hora de fin (rango)</label>
              <input className="f-inp" name="horaFin" type="time" value={form.horaFin} onChange={handle} />
            </div>
          </div>

          <div className="f-row">
            <div className="f-group">
              <label className="f-lbl">💻 Modalidad</label>
              <select className="f-inp" name="modalidad" value={form.modalidad} onChange={handle}>
                <option value="presencial">📍 Presencial</option>
                <option value="en_vivo">🌐 En Vivo (Online)</option>
              </select>
            </div>
            <div className="f-group">
              <label className="f-lbl">👥 Cupo (Personas)</label>
              <input className="f-inp" name="voluntariosNecesarios" type="number" min="1" value={form.voluntariosNecesarios} onChange={handle} />
            </div>
          </div>

          {form.modalidad === 'en_vivo' && (
            <div className="f-group">
              <label className="f-lbl">🔗 Link de transmisión (Zoom/Meet)</label>
              <input className="f-inp" name="linkTransmision" placeholder="https://zoom.us/j/..." value={form.linkTransmision} onChange={handle} />
            </div>
          )}

          <ImageUpload
            label="🖼️ Imagen de la actividad (opcional)"
            name="imagen"
            onFileSelect={setImagen}
          />

          <div className="p-4 border-2 border-vc rounded-2xl mb-5">
            <label className="flex items-center gap-3 font-bold cursor-pointer">
              <input type="checkbox" name="esDePago" checked={form.esDePago} onChange={handle} className="w-5 h-5" />
              Esta es una actividad de pago / con causa
            </label>

            {form.esDePago && (
              <div className="fade-up mt-4">
                <div className="f-group">
                  <label className="f-lbl">Precio de inscripción ($)</label>
                  <input className="f-inp" name="precio" type="number" min="0" value={form.precio} onChange={handle} required />
                </div>
                <div className="f-group">
                  <label className="f-lbl">🎯 Propósito de los fondos</label>
                  <textarea className="f-inp min-h-[60px]" name="propositoRecaudacion" placeholder="Especifique qué se hará con el dinero (Transparencia)" value={form.propositoRecaudacion} onChange={handle} required />
                </div>
              </div>
            )}
          </div>

          <div className="f-group">
            <label className="f-lbl">Ubicación / Detalles acceso</label>
            <input className="f-inp" name="ubicacion" placeholder="Ej: Auditorio A o Instrucciones acceso" value={form.ubicacion} onChange={handle} />
          </div>

          <div className="f-group">
            <label className="f-lbl">Descripción para alumnos</label>
            <textarea className="f-inp min-h-[80px] resize-y" name="descripcion" placeholder="¿Qué aprenderán? ¿Qué necesitan traer?" value={form.descripcion} onChange={handle} />
          </div>

          <button className="btn btn-v btn-full btn-lg" disabled={loading}>
            {loading ? 'Programando...' : 'Crear Clase / Actividad'}
          </button>
        </form>
      </div>
    </div>
  );
}
